import {
  gotoSite,
  replaceSite,
  goToShopEntity,
  navigateBack,
} from './navigation.actions';
import { take, put, select, call, takeLatest } from 'redux-saga/effects';
import { push, goBack, replace } from 'react-router-redux';
import { getStoryEditActiveAppId } from '../StoryEdit/story-edit.reducer';
import { getProductById } from '../Entities/Products/products.reducer';
import { strSlug } from '../../utils/string';
import { getBrandById } from '../Entities/Brands/brands.reducer';
import {
  TYPE_PRODUCT,
  TYPE_OUTFIT,
  TYPE_BRAND,
  TYPE_CATBRAND,
} from '../../modules/StoryEdit/components/Stream/TileTargetMenu/index';
import { AdditionalResourceData } from '../Entities/Stories/stories.reducer';
import { getBaseUrl } from '../../utils/url';
import { Action } from 'typescript-fsa';

export function* watchForNavigation() {
  const worker = function*(action: Action<string>) {
    yield put(push(action.payload));
  };

  yield takeLatest(gotoSite, worker);
}

export function* watchForReplaceSite() {
  const worker = function*(action: Action<string>) {
    yield put(replace(action.payload));
  };

  yield takeLatest(replaceSite, worker);
}

export function* watchForNavigateBack() {
  const worker = function*() {
    yield put(goBack());
  };

  yield takeLatest(navigateBack.type, worker);
}

export function* watchForGoToShopEntity() {
  while (true) {
    const {
      payload: {
        resource: { id, type, additionalResourceData },
        isMobile,
      },
    } = yield take(goToShopEntity.type);
    const state = yield select();
    const appId = getStoryEditActiveAppId(state);
    const baseUrl = getBaseUrl(isMobile);

    switch (type) {
      case TYPE_PRODUCT:
        yield call(goToProduct, baseUrl, appId, id);
        break;
      case TYPE_OUTFIT:
        goToOutfit(baseUrl, appId, id);
        break;
      case TYPE_BRAND:
        yield call(goToBrand, baseUrl, appId, id);
        break;
      case TYPE_CATBRAND:
        yield call(goToCatBrand, baseUrl, appId, id, additionalResourceData);
        break;
      default:
        break;
    }
  }
}

// product https://www.aboutyou.de/p/calvin-klein-jeans/t-shirt-tangan-cn-tee-ss-mit-front-print-3659778
export function* goToProduct(
  baseUrl: string,
  appId: number,
  productId: number
) {
  const state = yield select();
  const product = getProductById(state, appId, productId);

  if (product && product.brand) {
    const { name: brandName } = product.brand;
    const { name: productName } = product;

    const brandSlug = strSlug(brandName);
    const url = `${baseUrl}/p/${brandSlug}/${strSlug(
      productName
    )}-${productId}`;
    window.open(url, '_blank');
  }
}

// outfit https://www.aboutyou.de/o/max-giesinger-casual-leather-look-3912?category=236002
export function goToOutfit(baseUrl: string, appId: number, outfitId: number) {
  const url = `${baseUrl}/o/outfit-outfit-outfit-${outfitId}`;
  window.open(url, '_blank');
}

// brand https://www.aboutyou.de/about/brand/adidas-originals?category=20202
export function* goToBrand(baseUrl: string, appId: number, brandId: number) {
  const state = yield select();
  const brand = getBrandById(state, appId, brandId);
  if (brand) {
    const { name } = brand;
    const url = `${baseUrl}/about/brand/${strSlug(name)}`;
    window.open(url, '_blank');
  }
}

// https://www.aboutyou.de/about/brand/adidas-originals?category=20320
export function* goToCatBrand(
  baseUrl: string,
  appId: number,
  categoryId: number,
  additionalResourceData?: AdditionalResourceData
) {
  const state = yield select();
  const brandId = additionalResourceData && additionalResourceData.brandId;
  const brand = brandId && getBrandById(state, appId, brandId);

  if (brand) {
    const { name } = brand;
    const url = `${baseUrl}/about/brand/${strSlug(
      name
    )}?category=${categoryId}`;
    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/store/Navigation/navigation.saga.ts